<template>
  <div class="bs-wrapper question">
    <q-form>
      <div v-for="(item, idx) in value" :key="item.name">
        <field
          :name="item.name"
          :label="`${idx + 1}. ${item.title}（${typeText[item.type]}）`"
          :required="item.required"
          v-if="!['textarea', 'number'].includes(item.type)"
        >
          <template #input>
            <component
              :is="`${item.type}-group`"
              v-model="item.value"
              @change="changeHandler(item)"
              :disabled="canNotEdit"
            >
              <component
                v-for="child in item.ops"
                :is="item.type"
                :name="child"
                :shape="item.type === 'checkbox' ? 'square' : 'round'"
                checked-color="#FF6F00"
                icon-size="14px"
                :key="child"
              >
                {{ child }}
              </component>
            </component>
          </template>
        </field>
        <field
          v-else
          v-model="item.value"
          :disabled="canNotEdit"
          rows="4"
          autosize
          :required="item.required"
          :show-word-limit="item.type === 'textarea'"
          maxlength="300"
          :label="`${idx + 1}. ${item.title}`"
          :type="item.type"
          :placeholder="item.placeholder || '无'"
          :class="`field-${item.type}`"
          @focus="inputFocusHandler"
          @blur="inputBlurHandler(item.value)"
        />
      </div>
    </q-form>
  </div>
</template>

<script>
import 'vant/lib/form/style';
import 'vant/lib/field/style';
import 'vant/lib/checkbox/style';
import 'vant/lib/checkbox-group/style';
import 'vant/lib/radio/style';
import 'vant/lib/radio-group/style';

export default {
  name: 'Question',

  mixins: [],

  components: {
    QForm: () => import('vant/lib/form'),
    Field: () => import('vant/lib/field'),
    Radio: () => import('vant/lib/radio'),
    RadioGroup: () => import('vant/lib/radio-group'),
    Checkbox: () => import('vant/lib/checkbox'),
    CheckboxGroup: () => import('vant/lib/checkbox-group'),
  },

  model: {
    prop: 'value',
    event: 'change',
  },

  props: {
    value: {
      type: Array,
      default: () => [],
    },
    canNotEdit: {
      type: Boolean,
      default: false,
    },
    isCollection: { type: Boolean, default: false },
  },

  data() {
    return {
      typeText: {
        checkbox: '多选',
        radio: '单选',
      },
      options: [
        {
          name: '1',
          type: 'checkbox',
          required: true,
          title: '请问您是通过什么渠道了解XXX',
          value: [],
          ops: [
            {
              label: '选项一',
              value: '1',
            },
            {
              label: '选项二',
              value: '2',
            },
            {
              label: '选项三',
              value: '3',
            },
            {
              label: '选项四',
              value: '4',
            },
          ],
        },
        {
          name: '2',
          type: 'radio',
          required: true,
          title: '请问您是通过什么渠道了解XXX',
          value: '',
          ops: [
            {
              label: '选项一',
              value: '1',
            },
            {
              label: '选项二',
              value: '2',
            },
            {
              label: '选项三',
              value: '3',
            },
            {
              label: '选项四',
              value: '4',
            },
          ],
        },
        {
          name: '2',
          type: 'textarea',
          required: true,
          title: '其他建议',
          value: '',
          placeholder: '留下您宝贵的建议',
        },
      ],
    };
  },

  computed: {},

  watch: {},

  created() {},

  mounted() {},

  destroyed() {},

  methods: {
    inputFocusHandler() {
      if (/Android [4-6]/.test(navigator.appVersion)) {
        window.addEventListener('resize', function() {
          if (
            document.activeElement.tagName === 'INPUT' ||
            document.activeElement.tagName === 'TEXTAREA'
          ) {
            window.setTimeout(function() {
              document.activeElement.scrollIntoViewIfNeeded();
            }, 0);
          }
        });
      }
    },
    inputBlurHandler() {
      this.options.forEach(item => {
        if (item.type === 'textarea') {
          item.value = item.value.trim();
        }
      });
    },
    changeHandler(item) {
      if (['满意', '非常满意'].includes(item.value)) {
        item.showCollection = true;
      } else {
        item.showCollection = false;
        item.collection = '';
      }
    },
  },
};
</script>

<style lang="less" scoped>
.question {
  .van-form {
    /deep/ .van-field {
      flex-direction: column;
      &:after {
        border: none;
      }
    }
    /deep/ .van-cell__title,
    /deep/ .van-cell__value {
      width: 100%;
    }
    /deep/ .van-checkbox-group {
      margin-left: 15px;
      .van-checkbox {
        display: flex;
        align-items: flex-start;
        margin-top: 16px;
      }
    }
    /deep/ .van-radio-group {
      margin-left: 15px;
      .van-radio {
        margin-top: 16px;
        align-items: flex-start;
        .span {
        }
      }
    }
    /deep/ .field-textarea {
      textarea {
        height: 100px;
        border-radius: 4px;
        border: 1px solid #cccccc;
        margin-top: 10px;
        padding: 4px 8px 8px 8px;
      }
    }
    /deep/ .field-number {
      .van-field__value {
        box-sizing: border-box;
        border-radius: 4px;
        border: 1px solid #cccccc;
        margin-top: 10px;
        padding: 0 3px;
      }
    }
    /deep/ .van-radio__label {
      width: 300px;
    }
    /deep/ .van-radio__icon,
    /deep/ .van-checkbox__icon {
      margin-top: 3px;
    }
  }
}
.collection {
  border-radius: 4px;
  border: 1px solid #cccccc;
  width: 90%;
  float: right;
  margin-right: 10px;
}
</style>
